import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesShowResponseType } from "~/domains";

type RequestDataType = {
  id: string;
  page?: number;
};

const request = async ({
  id,
  page = 1,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesShowResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesShowResponseType>(
      `/api/admin_operators/companies/${id}`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsCompaniesShow = ({
  id,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApisAdminOperatorsCompaniesShowResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesShow", id],
    ({ pageParam }) => {
      return request({ id, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
